<script setup lang="ts">
interface IProps {
  value: number
  size?: 'xs' | 'sm' | 'md'
}

const props = withDefaults(defineProps<IProps>(), {
  size: 'md'
})

const sizeClassMap: Record<NonNullable<IProps['size']>, string> = {
  xs: 'size-3',
  sm: 'size-4',
  md: 'size-5'
}

const getStarFill = (index: number) => {
  if (index <= Math.floor(props.value)) return 100

  if (index === Math.ceil(props.value) && props.value % 1 !== 0)
    return Math.round((props.value % 1) * 100)

  return 0
}

const starPath =
  'M12 2.38419e-07L16.0174 7.98261L24 8.97391L18.5217 15.1826L20.0348 24L12 20.0348L3.96522 24L5.47826 15.1826L0 8.97391L7.98261 7.98261L12 2.38419e-07Z'

const strokeWidthMap: Record<NonNullable<IProps['size']>, number> = {
  xs: 0.5,
  sm: 0.75,
  md: 1
}
</script>

<template>
  <div class="flex gap-0.5">
    <template v-for="i in 5" :key="i">
      <svg
        width="24"
        height="24"
        :class="sizeClassMap[props.size]"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <mask :id="`mask-${i}-${props.value}`">
            <rect x="0" y="0" :width="`${(getStarFill(i) / 100) * 24}`" height="24" fill="white" />
          </mask>
        </defs>
        <!-- Empty star outline (stroke only) -->
        <path
          :d="starPath"
          fill="none"
          stroke="#ea580c"
          :stroke-width="strokeWidthMap[props.size]"
        />
        <!-- Filled star (orange, masked) -->
        <path :d="starPath" fill="#ea580c" :mask="`url(#mask-${i}-${props.value})`" />
      </svg>
    </template>
  </div>
</template>
